<template>
    <div class="container">
      <div class="content">
        <h2>🌍 Where Do You Purr? Identifying Your Country of Residence</h2>
        <p>Each location comes with its own set of financial climates. Let us know where you're purring from, so we can tailor our advice to your environment.</p>
        
        <div class="option" @click="selectOption('US')" :class="{ selected: isSelected('US') }">
          <span class="icon">🇺🇸</span>
          <b>United States: The Land of Opportunity and Diversity</b>
        </div>
        
        <div class="option" @click="selectOption('CA')" :class="{ selected: isSelected('CA') }">
          <span class="icon">🇨🇦</span>
          <b>Canada: Wide Open Spaces and Friendly Faces</b>
        </div>
        
        <div class="option" @click="selectOption('UK')" :class="{ selected: isSelected('UK') }">
          <span class="icon">🇬🇧</span>
          <b>United Kingdom: A Rich Tapestry of History and Culture</b>
        </div>
  
    
      </div>
    </div><br><br><br>
  </template>
  
  <script>
  import { onboardingStore } from '@/components/stores/onboardingStore';
  
  export default {
    setup() {
      const store = onboardingStore();
  
      const selectOption = (option) => {
        // Set the selected option directly
        store.updateFormData({ country_of_residence: option });
      };
  
      // Helper method to check if an option is selected
      const isSelected = (option) => store.formData.country_of_residence === option;
      
  
      return { store, selectOption, isSelected };
    },
  };
  </script>
<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
background-color: white;
padding: 20px;
border-radius: 10px;
color: black;
}

.option {
padding: 10px;
border: 1px solid #ccc;
border-radius: 10px;
text-align: center;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
cursor: pointer;
transition: transform 0.3s ease, box-shadow 0.3s ease;
margin-bottom: 10px;
}

.option:hover {
transform: translateY(-5px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


button {
  grid-column: span 2;
  background-color: #4A148C; /* Dark purple */
  color: white;
  padding: 10px 15px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
}

button:hover {
  background-color: black; /* Black background on hover */
}

.selected {
background-color: #4A148C; /* More solid color for selection */
color: white;
}


.icon {
font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>